import { render } from "./Vacations.vue?vue&type=template&id=b35085b4&scoped=true"
import script from "./Vacations.vue?vue&type=script&lang=js"
export * from "./Vacations.vue?vue&type=script&lang=js"

import "./Vacations.vue?vue&type=style&index=0&id=b35085b4&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35085b4"]])

export default __exports__